import { Outlet } from 'react-router-dom';

import { SidebarProvider, SidebarInset } from '@/components/ui/Sidebar';
import { AppSidebar } from '@/components/layout/AppSidebar';
import { PageHeader } from '@/components/layout/PageHeader';
import InitialPopUp from '@/pages/initial-pop-up/InitialPopUp';
import { useGetUser } from '@/hooks';
import { FINAL_USERS } from '@/enums';

const GlobalLayout = () => {
  const { currentUser, company } = useGetUser();

  return (
    <SidebarProvider>
      {!FINAL_USERS.includes(currentUser?.type) && !company?.scaleAccess && <InitialPopUp />}
      <AppSidebar />
      <SidebarInset className='flex flex-col min-w-0 max-h-svh'>
        <PageHeader />
        <main className='flex-1 min-h-0 overflow-auto px-5 py-5'>
          <div className='mx-auto max-w-full min-w-0'>
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default GlobalLayout;
